import React, { useContext } from 'react'

const WizardFormContext = React.createContext()

export default WizardFormContext
export const useWizardFormContext = () => useContext(WizardFormContext)
